import { Select, type SelectProps } from 'antd'

type Props = {
  colors?: string[]
} & SelectProps

export const PRIMARY_COLORS = [
  '#1677ff',
  '#1890ff',
  '#722ed1',
  '#eb2f96',
  '#f5222d',
  '#fa541c',
  '#fa8c16',
  '#a0d911',
  '#52c41a',
  '#13c2c2',
]

const ColorSwatch = ({ color }: { color: string }) => (
  <span
    className="mr-2 inline-block rounded-sm border"
    style={{
      backgroundColor: color,
      width: '38px',
      height: '20px',
      borderColor: 'rgba(0,0,0,0.1)',
    }}
  />
)

export const FormColorSelect = ({
  colors = PRIMARY_COLORS,
  ...props
}: Props) => (
  <Select
    optionRender={(option) => (
      <div className="flex items-center">
        <ColorSwatch color={option.value?.toString() || ''} />
      </div>
    )}
    options={colors.map((color) => ({
      value: color,
      label: (
        <div className="flex items-center">
          <ColorSwatch color={color} />
        </div>
      ),
    }))}
    tagRender={(props) => (
      <div className="ant-select-selection-item">
        <ColorSwatch color={props.value} />
      </div>
    )}
    {...props}
  />
)
